import {
  DivContainerTable,
  DivContentTable,
  StyledTable,
} from "../AdminReportStyle";
import { SearchGetRegister } from "../SearchGetRegister";
import { Volante } from "../interfaces/Volantes.interfaces";
import { StatusType } from "../AdminReportResource";
import { NULL, PROCESSING, SUCCESS } from "../../../utils/valueStaticConstants";

interface Props {
  statusEndpoint: StatusType;
  loadReportExecutor: any;
}
export const ReportVolante = (props: Props) => {
  const { loadReportExecutor, statusEndpoint } = props;

  const showBackground =
    (loadReportExecutor.status === SUCCESS &&
      statusEndpoint === SUCCESS &&
      loadReportExecutor.data.count === 0) ||
    loadReportExecutor.status === PROCESSING
      ? true
      : statusEndpoint === NULL
      ? true
      : false;

  return (
    <div>
      <DivContainerTable>
        <DivContentTable>
          <StyledTable id="resizeMe">
            <thead>
              <tr>
                <th style={{ resize: "horizontal" }}>{"Número Volante"}</th>
                <th style={{ resize: "horizontal" }}>
                  {"RUC de la Agencia Aduanera"}
                </th>
                <th style={{ resize: "horizontal" }}>{"Agencia Aduanera"}</th>
                <th style={{ resize: "horizontal" }}>
                  {"Fecha de retiro de la carga"}
                </th>
                <th style={{ resize: "horizontal" }}>
                  {"Estado de pago del volante"}
                </th>
                <th style={{ resize: "horizontal" }}>
                  {" "}
                  {"Estado de pago de la prefactura"}
                </th>
                <th style={{ resize: "horizontal" }}>
                  {" "}
                  {"Estado de pago de la factura"}
                </th>
                <th style={{ resize: "horizontal" }}>
                  {" "}
                  {"Primera consulta del volante"}
                </th>
                <th style={{ resize: "horizontal" }}>{"RUC facturable"}</th>
                <th style={{ resize: "horizontal" }}>
                  {" "}
                  {"Nombre RUC del facturable"}
                </th>
                <th style={{ resize: "horizontal" }}>
                  {" "}
                  {"Tipo RUC facturable"}
                </th>
                <th style={{ resize: "horizontal" }}>
                  {" "}
                  {"Creación de la prefactura"}
                </th>
                <th style={{ resize: "horizontal" }}>
                  {" "}
                  {"Última actualización de la prefactura"}
                </th>
                <th style={{ resize: "horizontal" }}>
                  {" "}
                  {"Número de pedido en SAP"}
                </th>
                <th style={{ resize: "horizontal" }}>{"Tipo de pago"}</th>
                <th style={{ resize: "horizontal" }}>
                  {"Tipo de RUC pagador"}
                </th>
                <th style={{ resize: "horizontal" }}>{"RUC pagador"}</th>
                <th style={{ resize: "horizontal" }}>
                  {" "}
                  {"Nombre del RUC pagador"}
                </th>
                <th style={{ resize: "horizontal" }}>
                  {" "}
                  {"Usuario quien aprobó el pago"}
                </th>
                <th style={{ resize: "horizontal" }}>
                  {" "}
                  {"Número de factura en SAP"}
                </th>
                <th style={{ resize: "horizontal" }}>{"Monto soles"}</th>
                <th style={{ resize: "horizontal" }}>{"Monto dólares"}</th>
                <th style={{ resize: "horizontal" }}>{"Fecha de pago"}</th>
                <th style={{ resize: "horizontal" }}>
                  {"Usuario quién compensó el pago"}
                </th>
                <th style={{ resize: "horizontal" }}>
                  {"Usuario del agente aduanero que participó en el proceso"}
                </th>
              </tr>
            </thead>

            {loadReportExecutor.status === SUCCESS &&
              statusEndpoint === SUCCESS && (
                <tbody>
                  {loadReportExecutor.data.data_report.map(
                    (elem: Volante, idx: number) => {
                      return (
                        <tr key={idx}>
                          <td>{elem.volante_num}</td>
                          <td>{elem.agent_ruc}</td>
                          <td>{elem.agent_name}</td>
                          <td>{elem.withdrawal_date}</td>
                          <td>
                            {elem.volante_payment_status.label
                              ? elem.volante_payment_status.label
                              : "-"}
                          </td>
                          <td>
                            {elem.quotation_payment_status.label
                              ? elem.quotation_payment_status.label
                              : "-"}
                          </td>
                          <td>
                            {elem.invoice_payment_status.label
                              ? elem.invoice_payment_status.label
                              : "-"}
                          </td>
                          <td>{elem.volante_created_at}</td>
                          <td>{elem.billable_ruc}</td>
                          <td>{elem.billable_ruc_name}</td>
                          <td>{elem.billable_ruc_option}</td>
                          <td>{elem.quotation_created_at}</td>
                          <td>{elem.quotation_updated_at}</td>
                          <td>{elem.id_pedido}</td>
                          <td>{elem.payment_type}</td>
                          <td>{elem.payer_ruc_option}</td>
                          <td>{elem.payer_ruc}</td>
                          <td>{elem.payer_ruc_name}</td>
                          <td>{elem.user_email_approved_by}</td>
                          <td>{elem.tci_num}</td>
                          <td>{elem.sales_invoice_price_pen}</td>
                          <td>{elem.sales_invoice_price_usd}</td>
                          <td>{elem.payment_date}</td>
                          <td>{elem.compensated_by}</td>
                          <td>{elem.user_invoice_full_name}</td>
                        </tr>
                      );
                    }
                  )}
                </tbody>
              )}
          </StyledTable>
        </DivContentTable>
      </DivContainerTable>

      {showBackground && <SearchGetRegister />}
    </div>
  );
};
